import { Tooltip } from '@mui/material';
import { BudgetBys } from 'business/constants';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { isCustomBudgetProposal } from '../../BudgetProposal/Resource/hooks/budgetProposal';
import { getClientBind } from 'store/APIClient';
import { capitalize } from 'helpers/helpers';
import { getResourceLabel } from 'routes/BudgetModule/components/shared/helpers/getResourceLabel';
import { IntegrationContext } from 'routes/BudgetModule/components/BudgetWithProvider/IntegrationContext';
import { isAmp } from 'routes/BudgetModule/helpers/bind';

/**
 * Small component to display a tooltip based on a flag that indicates
 * why the update is disabled.
 * This is wrapper to avoid adding complexity to the main component.
 */
export const UpdateDisabledTooltip = ({
    disabledByResource,
    disabledByPhase,
    isSupplementaryNotEditable,
    disabledByRights,
    hidden,
    by = undefined,
    children,
}: {
    disabledByResource: boolean;
    disabledByPhase: boolean;
    isSupplementaryNotEditable: boolean;
    disabledByRights: boolean;
    hidden: boolean;
    by?: BudgetBys;
    children: JSX.Element;
}) => {
    const { t } = useTranslation();
    const integrations = useContext(IntegrationContext);
    const isSchool = isCustomBudgetProposal(integrations);
    const bind = getClientBind();
    if (
        (!disabledByResource && !disabledByPhase && !disabledByRights) ||
        hidden ||
        !by
    ) {
        return <>{children}</>;
    }

    let title;
    const article = isAmp(bind) ? 'cette' : 'ce';
    const resourceType = getResourceLabel(by, isSchool, bind);

    if (disabledByResource) {
        title = t('budgetProposal.updateDisabled', {
            article,
            resourceType,
        });
    } else if (disabledByPhase || isSupplementaryNotEditable) {
        title = t('budgetProposal.updateDisabledGeneric');
    } else if (disabledByRights) {
        title = t('budgetProposal.updateDisabledByRights', {
            article: capitalize(article),
            resourceType,
        });
    }
    return <Tooltip title={title}>{children}</Tooltip>;
};
